import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderServiceService } from 'src/app/services/orders/order-service.service';

@Component({
  selector: 'app-checkout-url-redirection',
  templateUrl: './checkout-url-redirection.component.html',
  styleUrls: ['./checkout-url-redirection.component.scss'],
})
export class CheckoutUrlRedirectionComponent {
  id: string;
  transactionData: any;
  value: number = 0;
  paymentMethod: string = '';
  currentStatus: string = '';
  isLoading: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private orderService: OrderServiceService,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.id = params['id'];
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;

      const transaction: any = await this.orderService.getTransaction(this.id);

      if (!transaction || !transaction.data) {
        throw new Error('Datos de transacción no válidos');
      }

      this.addStatusInParams(transaction?.data.status);
      this.transactionData = transaction.data;
      this.currentStatus = this.getStatusPayment(this.transactionData?.status);
      this.value = Math.floor(this.transactionData.amount_in_cents / 100);
      let paymentMethod = this.transactionData?.payment_method?.type;
      this.paymentMethod =
        paymentMethod[0].toUpperCase() + paymentMethod.slice(1).toLowerCase();
      this.isLoading = false;
    } catch (error) {
      console.error('Error al cargar la transacción:', error);
    } finally {
      this.isLoading = false;
    }
  }

  addStatusInParams(status: string) {
    this.router.navigate([], {
      queryParams: { status: status },
      queryParamsHandling: 'merge',
    });
  }

  getStatusPayment(status: string) {
    let statusTranslated: string = '';
    switch (status) {
      case 'APPROVED':
        statusTranslated = 'APROBADA';
        break;
      case 'VOIDED':
        statusTranslated = 'ANULADA';
        break;
      case 'DECLINED':
        statusTranslated = 'RECHAZADA';
        break;
      case 'PENDING':
        statusTranslated = 'PENDIENTE';
        break;
      default:
        statusTranslated = status;
        break;
    }
    return statusTranslated;
  }

  formatDate(isoDate) {
    let date = new Date(isoDate);
    date.setHours(date.getHours() - 5);
    return this.orderService.formatDate(date);
  }

  close() {
    window.close();
  }

  redirectToMarketplace(){
    window.open("https://riverapp.com.co/home", '_self');
  }

  redirectToOrdersInMarketplace(){
    window.open("https://riverapp.com.co/user/orders", '_self');
  }

  isWebView(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroidWebView = /; wv/.test(userAgent) && /android/.test(userAgent);
    const isIOSWebView = /(iphone|ipad|ipod).*applewebkit/.test(userAgent) && !/(safari|chrome|firefox)/.test(userAgent);
    return isAndroidWebView || isIOSWebView;
  }
}
